export default "__VITE_ASSET__DuIUYFNP__"